import React      from 'react';
import LeadMap    from "../components/Leadmap/LeadMap";
import {
    mapService,
    NotificationService
}                 from "../services";
import DatePicker from "react-datepicker";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import {Col, Input, Label, Row} from "reactstrap";
import NotificationAlert
                  from 'react-notification-alert/index';
import { salesAreaService } from 'services/sales.area.service';

class Leadmap extends React.Component {
    constructor(props) {
        super(props);
        var fd = moment().subtract('months', 1).toDate();
        this.state = {
            leadData: {
                type: "FeatureCollection",
                features: []
            },
            regionData: {
                type: "FeatureCollection",
                features: []
            },
            suburbData: {
                type: "FeatureCollection",
                features: []
            },
            postcodeList: "",
            filterDateStart:  Date.parse(fd),
            filterDateEnd: Date.parse(new Date())
        }
        var timer;
    }

    handleStartChange = (d) => {
        this.setState({filterDateStart: d.getTime()}, () => this.updateLeads())
    }

    handleEndChange = (d) => {
        this.setState({filterDateEnd: d.getTime()}, () => this.updateLeads())
    }

    fetchSuburbLists = (event) => {
        console.log(event.target.value)
        this.setState({postcodeList: event.target.value}, () => {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.updateSuburbGeom();
            }, 2000)
        });
    }

    updateSuburbGeom = () => {
        if (this.state.postcodeList.length < 4) {
            return
        }
        salesAreaService.getSuburbGeom(this.state.postcodeList).then(res => {
            console.log(res)
            var outer = {
                type: "FeatureCollection",
                features: []
            }
            res.forEach(r => {
                outer.features.push({
                    "id": r.PolyID,
                    "type": "Feature",
                    "properties": JSON.parse(r.PolyProperties),
                    "geometry": r.PolyGeom
                })
            })
            this.setState({suburbData:outer})
        })
    }



    componentDidMount() {
        mapService.getAllRegions().then(response => {
            var outer = {
                type: "FeatureCollection",
                features: []
            }
            response.forEach(r => {
                outer.features.push({
                    "id": r.PolyID,
                    "type": "Feature",
                    "properties": JSON.parse(r.PolyProperties),
                    "geometry": r.PolyGeom
                })
            })
            this.setState({regionData:outer})
            this.updateLeads();
        }).catch(error => {
            this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 4, "Error: "+error+". Functionality is disabled."));
        })
    }

    updateLeads = () => {
        mapService.getLeadMarkers(this.state.filterDateStart, this.state.filterDateEnd).then(response => {
            var outer = {
                type: "FeatureCollection",
                features: []
            }
            if (response) {
                response.forEach(r => {
                    outer.features.push({
                        "type": "Feature",
                        "geometry": {
                            type: 'Point',
                            coordinates:[
                                r.Longitude,
                                r.Latitude
                            ]
                        },
                        'properties': {
                            'title': 'Mapbox DC',
                            'icon': 'monument'
                        }
                    })
                });

            }
            if (outer.features.length > 0) {
                this.setState({leadData: outer})
            }

        });
    }


    render() {
        return (
            <>
                <NotificationAlert ref="notificationAlert" />
                <div className="content">
                    <Row>
                        <Col xs="12">
                            <div className={`lead-map--info--wrapper`}>
                                <div className={`lead-map--info--total`}>Leads: {this.state.leadData && this.state.leadData.features != undefined && this.state.leadData.features.length}</div>
                                <div>
                                    <span className={`inline-date-picker`}>
                                Start Date <DatePicker
                                        selected={this.state.filterDateStart}
                                        onChange={this.handleStartChange}
                                        dateFormat={'yyyy-MM-dd'}
                                        withPortal
                                        showYearDropdown
                                    />
                                    </span>
                                </div>
                                <div>
                                <span className={`inline-date-picker`}>End Date
                                    <DatePicker
                                        selected={this.state.filterDateEnd}
                                        onChange={this.handleEndChange}
                                        dateFormat={'yyyy-MM-dd'}
                                        withPortal
                                        showYearDropdown
                                    />
                                </span>
                                </div>
                                <div>
                                    <Label for="postcodeList">Postcodes (comma seperated)</Label>
                                    <Input id="postcodeList" style={{color: 'black'}} value={this.state.postcodeList} onChange={this.fetchSuburbLists}></Input>
                                </div>
                            </div>
                            {
                                <LeadMap suburbData={this.state.suburbData} leadData={this.state.leadData} regionData={this.state.regionData}/>
                            }

                        </Col>
                    </Row>
                </div>
            </>
        )
    }
}

export default Leadmap